<template>
    <div class="refund-appli">
        <div class="top-nav">
            <el-button size="mini" @click="()=> { $router.back(-1) }">返回</el-button>
            <span v-has="'06020015'">
                <el-button size="mini" class="el-button el-button--primary margin-left" @click="save"
                    :disabled="headInfo.orderType === '3' && (headInfo.costStatus === '2' || headInfo.costStatus === '3' ||
                    headInfo.costStatus === '6' || headInfo.costStatus === '7')">保存</el-button>
            </span>
            <span v-has="'06020016'">
                <el-button size="mini" class="el-button el-button--primary margin-left" @click="refundStamp">退款申请函盖章</el-button>
            </span>

        </div>
        <div class="refund-appli-cont">
            <div class="content">
                <div class="content-box">
                    <div><span class="content-title">{{headInfo.bidName}}</span><span class="content-label">{{headInfo.costStatusText}}</span></div>
                    <div class="content-desc" v-if="headInfo.orderType!=='3'">
                        <span class="content-desc-item">订单号<span class="content-desc-cont">{{headInfo.orderNo}}</span></span>
                        <span class="content-desc-item">招标项目编号<span class="content-desc-cont">{{headInfo.bidNo}}</span></span>
                        <span class="content-desc-item">订单类型<span class="content-desc-cont">{{headInfo.orderTypeText}}</span></span>
                        <span class="content-desc-item">应缴金额<span class="content-desc-cont">{{headInfo.receivePayAmount || 0}}</span></span>
                        <span class="content-desc-item">实缴金额<span class="content-desc-cont">{{headInfo.actualReceivePay || 0}}</span></span>
                        <span class="content-desc-item">罚扣款金额<span class="content-desc-cont">{{headInfo.penaltyAmount || 0}}</span></span>
                        <span class="content-desc-item">转合同押金金额<span class="content-desc-cont">{{headInfo.depositContract || 0}}</span></span>
                        <span class="content-desc-item">缴纳方式<span class="content-desc-cont">{{headInfo.payTypeText}}</span></span>
                        <span class="content-desc-item">下单时间<span class="content-desc-cont">{{headInfo.orderTime}}</span></span>
                        <span class="content-desc-item">付款时间<span class="content-desc-cont">{{headInfo.transactionTime}}</span></span>
                    </div>
                    <div class="content-desc" v-if="headInfo.orderType==='3'">
                        <span class="content-desc-item">退款单号<span class="content-desc-cont">{{headInfo.orderNo}}</span></span>
                        <span class="content-desc-item">招标项目编号<span class="content-desc-cont">{{headInfo.bidNo}}</span></span>
                        <span class="content-desc-item">原保证金缴纳金额<span class="content-desc-cont">{{headInfo.orginDepositAmount || 0}}</span></span>
                        <span class="content-desc-item">罚扣款金额<span class="content-desc-cont">{{headInfo.penaltyAmount || 0}}</span></span>
                        <span class="content-desc-item">转合同押金金额<span class="content-desc-cont">{{headInfo.depositContract || 0}}</span></span>
                        <span class="content-desc-item">应退保证金金额<span class="content-desc-cont">{{headInfo.receiveRefundDeposit || 0}}</span></span>
                        <span class="content-desc-item" v-if="headInfo.costStatus!=='1'">实退保证金金额<span class="content-desc-cont">
                            {{headInfo.actualReceivePay || 0}}</span></span>
                        <span class="content-desc-item">开户银行<span class="content-desc-cont">{{headInfo.bankCode}}</span></span>
                        <span class="content-desc-item">银行账号<span class="content-desc-cont">{{headInfo.bankAccount}}</span></span>
                        <span class="content-desc-item">下单时间<span class="content-desc-cont">{{headInfo.orderTime}}</span></span>
                    </div>
                </div>
                <div class="content-right">
                    <div class="content-right-box">
                        <div><span class="money">{{headInfo.priceDifference}} </span>元</div>
                        <div class="money-text">应退金额</div>
                    </div>
                </div>
            </div>
            <div class="pd-10">
                <div class="upload-enclosure">
                    <div class="upload-enclosure-text">申请退款</div>
                </div>
                <div class="refund-box">
                    <div class="refund-box-text">填写退款信息</div>
                    <el-form>
                        <div class="from-sty">
                            <div class="from-sty-text">银行账户</div>
                            <el-form-item prop="enrollEndTime" class="from-sty-item">
                                <mInput :params="accountEntityData" @getAdvanceValue="getAccountEntity" :mValue="bankInfo.bankAccount"></mInput>
                            </el-form-item>
                        </div>
                        <div class="from-sty">
                            <div class="from-sty-text">开户行</div>
                            <el-form-item prop="enrollEndTime" class="from-sty-item">
                                <el-input v-model="bankInfo.bankName" disabled></el-input>
                            </el-form-item>
                        </div>
                        <div class="from-sty">
                            <div class="from-sty-text">账户名称</div>
                            <el-form-item prop="enrollEndTime" class="from-sty-item">
                                <el-input v-model="bankInfo.bankAccountName" disabled></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </div>
        </div>
        <Bid-Price-List
            :payTitle="'退款申请函盖章'"
            :originFlag="'2'"
            :refundFileInfo="refundFileInfo"
            :MDialogshow="bidPayshow"
            :rowBidDialogData="bidPayshowRowData"
            @mdialogFn="mdialogFn">
        </Bid-Price-List>
    </div>
</template>
<script>
import mInput from '@/components/lots/otpAdvance';
import BidPriceList from '../bidManagement/BidPriceList.vue';
import { saveRefundDeposit, bidSupplierCostList, contractDeposit } from '../../../../lsrm/api/tenderCost.js';
import { getSupplierCostByBond } from '../../../../lsrm/api/myBidding.js';
import { dictWithUrl } from '@/components/lots/api';
export default {
    name: 'refund-appli',
    components: {
        mInput,
        BidPriceList
    },
    data() {
        return {
            saveSendRefundStamp: false, // 是否盖过章
            bidPayshow: false,
            bidPayshowRowData: {},
            headInfo: {},
            accountEntityData: {
                name: '',
                value: 'bankAccount',
                advanceLabel: '选择银行账户',
                advanceConfig: [
                    { prop: 'bankAccount', value: '银行账户' },
                    { prop: 'bankAccountName', value: '账户名称' },
                    { prop: 'ubankNo', value: '银联号' },
                    { prop: 'bankName', value: '银行名称' }
                ],
                tableConfig: [
                    { prop: 'bankAccount', value: '银行账户' },
                    { prop: 'bankAccountName', value: '账户名称' },
                    { prop: 'ubankNo', value: '银联号' },
                    { prop: 'bankName', value: '银行名称' }
                ],
                advanceUrl: `/supplier/bankAccounts/${this.$route.query.supplierCode}/`,
                prefix: '/api-srm-web',
                cbParams: ['bankAccount', 'bankName', 'bankAccountName', 'bankCode']
            },
            bankInfo: {
                bankAccount: '',
                bankName: '',
                bankAccountName: '',
                bankCode: ''
            },
            refundFileInfo: [],
            dictData: []
        };
    },
    mounted() {
        dictWithUrl('BID_EXPENSE_ORDER_TYPE,BID_PAY_TYPE,BID_COST_STATUS').then(res => {
            this.dictData = res.data;
            this.contractDepositFunc();
        });
    },
    methods: {
        contractDepositFunc() {
            const par = { 'bidNo': this.$route.query.bidNo, 'bidFeeCode': this.$route.query.orderNo };
            contractDeposit(par).then(res => {
                if (res && +res.code === 0) {
                    this.getSupplierCostByBondFunc();
                }
            });
        },
        getSupplierCostByBondFunc() {
            const param = {
                bidNo: this.$route.query.bidNo,
                supplierCode: this.$route.query.supplierCode,
                orderType: '3'
            };
            getSupplierCostByBond(param).then(res => {
                if (res && +res.code === 0) {
                    this.headInfo = this.parameReset(res.data);
                    if (!this.headInfo.actualReceivePay) {
                        this.headInfo.priceDifference = this.headInfo.receivePayAmount;
                    } else {
                        this.headInfo.priceDifference = this.sub(this.headInfo.actualReceivePay, this.headInfo.penaltyAmount);
                        this.headInfo.priceDifference = this.sub(this.headInfo.priceDifference, this.headInfo.depositContract);
                    }
                    this.bidPayshowRowData = this.headInfo;
                    this.refundFileInfo = this.bidPayshowRowData.bidModuleFiles || [];
                    this.getBankInfo();
                }
            });
        },
        getBankInfo() {
            const param = {
                bidNo: this.headInfo.bidNo,
                supplierCode: this.headInfo.supplierCode,
                orderType: '3'
            };
            bidSupplierCostList(param).then(res => {
                if (res && +res.code === 0) {
                    this.bankInfo = res.data.list[0] || {};
                }
            });
        },
        sub(arg1, arg2) {
            // 减法精度处理
            let r1 = ''; let r2 = ''; let m = ''; let n = '';
            try { r1 = arg1.toString().split('.')[1].length; } catch (e) { r1 = 0; }
            try { r2 = arg2.toString().split('.')[1].length; } catch (e) { r2 = 0; }
            m = Math.pow(10, Math.max(r1, r2));
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m) / m).toFixed(n);
        },
        refundStamp(row) {
            this.bidPayshow = true;
        },
        mdialogFn(type) {
            this.bidPayshow = false;
            if (type) {
                this.saveSendRefundStamp = true;
            }
        },
        save() {
            if (!this.bankInfo.bankAccount) {
                this.$message.warning('请先选择银行卡信息！');
                return;
            }
            const param = {
                bidNo: this.headInfo.bidNo,
                supplierCode: this.headInfo.supplierCode,
                supplierName: this.$store.state.supplier.supplierNameCn,
                bankAccount: this.bankInfo.bankAccount,
                bankCode: this.bankInfo.bankCode,
                bankName: this.bankInfo.bankName,
                bankAccountName: this.bankInfo.bankAccountName,
                orderNo: this.headInfo.orderNo,
                receivePayAmount: this.headInfo.priceDifference
            };
            saveRefundDeposit(param).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(' 保存成功！');
                    this.getSupplierCostByBondFunc();
                }
            });
        },
        getAccountEntity(val) {
            this.bankInfo = val;
        },
        parameReset(data) {
            const el = { ...data };
            el.orderTypeText = this.dictData.BID_EXPENSE_ORDER_TYPE[el.orderType];
            el.payTypeText = this.dictData.BID_PAY_TYPE[el.payType];
            el.costStatusText = this.dictData.BID_COST_STATUS[el.costStatus];
            return el;
        }
    }
};
</script>

<style lang="less">
.refund-appli {
    margin: 0 10px;
    font-size: 12px;
    background: #fff;
    .margin-left {
        margin-left: 10px;
    }
    .refund-appli-cont {
        overflow-y: auto;
        min-height: calc(~"100vh - 110px") !important;
        max-height: calc(~"100vh - 110px") !important;
    }
    .content-box {
        width: 100%;
    }
    .content-right-box {
        margin-right:30px;
        width: 108px;
    }
    .money-text {
        margin-top:4px;
    }
    .pd-10 {
        padding:10px;
    }
    .refund-box-text {
        margin-bottom: 15px;
    }
    .top-nav {
        padding-left: 10px;
        width: 100%;
        height: 46px;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        box-sizing: border-box;
    }
    .content {
        margin: 10px;
        padding: 14px;
        min-width: 1400px;
        box-sizing: border-box;
        background: #F8F8F8;
        vertical-align: middle;
        display: flex;
        align-items: center;
        .content-title {
            margin-bottom: 15px;
            font-size: 16px;
            font-weight: 700;
        }
        .content-label {
            margin-left: 12px;
            padding: 3px 6px;
            border-radius: 2px;
            background: #FF7C24;
            display: inline-block;
            color: #fff;
        }
        .content-desc {
            margin-top: 15px;
            width: 70%;
            display: flex;
            flex-wrap: wrap;
        }
        .content-desc-item {
            margin: 0 20px 4px 0;
            color: #888888;
        }
        .content-desc-cont {
            margin-left: 5px;
            color: #333333;
        }
        .content-right {
            margin-right: 30px;
            display: flex;
        }
        .money {
            font-size: 18px;
            font-weight: 700;
            color: #FF8800;
        }
    }
    .el-tabs__item {
        font-size: 12px;
    }
    .payIframe {
        width: 100%;
        height: 100%;
        border: none;
    }
    .upload-enclosure {
        margin-bottom: 10px;
        width:100%;
        display: flex;
        justify-content: space-between;
    }
    .upload-enclosure-text {
        font-weight: 700;
    }
    .upload_enclosure_top {
        color:#00BCBF;
        cursor:pointer;
        display: flex;
        align-items: center;
    }
    .refund-box {
        border: 1px solid #e5e5e5;
        padding: 20px;
    }
    .el-form-item {
        margin-bottom: 0px;
    }
    .from-sty {
        display:flex;
        align-items:center;
        margin-bottom: 10px;
    }
    .from-sty-text {
        margin-right:10px;
        width: 60px;
        text-align: end;
    }
    .from-sty-item {
        width: 300px;
    }
    .el-form-item__content {
        line-height: 1
    }
    .el-input.is-disabled .el-input__inner {
        color: #333;
    }
}
</style>